<template>
	<div class="fileDiv" :class="{[`${classPrefix}-transform`]: true, [`${classPrefix}-transform--active`]:selected}" @click="click" @dblclick="dblClick" @mousedown="mousedown">
		<div :class="`${classPrefix}-transform__content`" :style="[computedStyles.element,styles]">
			<slot></slot>
		</div>
		<!--Alt => 看板
			如果需要随着变化 则在:style数组中加UpdataScale
		-->
		<div :class="{'DarkMould' : mouldId == 4 || mouldId == 5 || mouldId == 6}"
			v-if="dataBlock.length != 0 && item.type=='img' && (item.DeviceId != null || item.DeviceId != undefined) && AttrShow  && dataBlock.filter(itemData => itemData.id == item.DeviceId).length != 0 "
			class="AltBlock clearfix"
			:style="[computedStylesBlock.element]"
		>
			<div class="abBox">
				<div class="topBox clearfix">
					<div class="Block-title">
						{{dataBlock.filter(itemData => itemData.id == item.DeviceId)[0].name}}
					</div>

					<div class="Block-body">
						<div class="Block-box" v-if="BlockArr.includes(itemA.identifier)" v-for="(itemA,index) in dataBlock.filter(itemData => itemData.id == item.DeviceId)[0].data">
							{{ showData(itemA) }}
							<!--{{itemA.name}} :  {{itemA.selectOptions[Number(itemA.value)]}} {{itemA.unit ? itemA.unit : ''}}-->
							<!--{{itemA.name}} :  {{itemA.value}} {{itemA.unit ? itemA.unit : ''}}-->
						</div>
					</div>
				</div>
			</div>
			<div class="Block_line">
				<div class="Block_circ"></div>
			</div>

		</div>
		<!--<div v-if="selected" :class="`${classPrefix}-transform__controls`" :style="[computedStyles.controls,stylesoutline]">
			<div :class="`${classPrefix}-transform__rotator`" :style="trTransform" @mousedown="handleRotation"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--tl`]" @mousedown="handleScale('tl',$event)" :style="trTransform"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--ml`]" @mousedown="handleScale('ml',$event)" :style="trTransform"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--tr`]" @mousedown="handleScale('tr',$event)" :style="trTransform"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--tm`]" @mousedown="handleScale('tm',$event)" :style="trTransform"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--bl`]" @mousedown="handleScale('bl',$event)" :style="trTransform"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--bm`]" @mousedown="handleScale('bm',$event)" :style="trTransform"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--br`]" @mousedown="handleScale('br',$event)" :style="trTransform"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--mr`]" @mousedown="handleScale('mr',$event)" :style="trTransform"></div>
		</div>-->
	</div>
</template>

<script>
	import { styler, scale, translate, rotate } from 'free-transform'

	export default {
		name: 'Transform',
		props: {
	    	mouldId: {
	    		type: Number,
				default: "",
	    	},
	    	BlockArr: {
	    		default: function() {
				    return [];
			    },
			    type: Array
	    	},
		    dataBlock: {
			    default: function() {
				    return [];
			    },
			    type: Array
		    },
		    dataName: {
          type: Boolean,
          default: false,
		    },
		    AttrShow: {
				type: Boolean,
				default: false,
		    },
			zIndex: {
				type: Number,
				default: 1
			},
			item: {
				type: Object,
				default: () => ({})
			},
			stylesoutline: {
				type: Object,
				default: () => ({})
			},
			spaceMark: {
				type: Boolean,
				default: false,
			},
			classPrefix: {
				type: String,
				default: "tr",
			},
			width: {
				type: Number,
				required: true
			},
			height: {
				type: Number,
				required: true
			},
			x: {
				type: Number,
				required: true
			},
			y: {
				type: Number,
				required: true
			},
			scaleX: {
				type: Number,
				required: true
			},
			scaleY: {
				type: Number,
				required: true
			},
			scaleLimit: {
				type: Number,
				default: 0.1
			},
			angle: {
				type: Number,
				required: true
			},
			disableScale: {
				type: Boolean,
				default: false,
			},
			selected: {
				type: Boolean,
				default: true
			},
			styles: {
				type: Object,
				default: () => ({})
			},
			selectOn: {
				validator: function(value) {
					return ['dblclick', 'mousedown', 'click'].indexOf(value) !== -1
				},
				default: 'mousedown'
			},
			aspectRatio: {
				type: Boolean,
				default: true
			},
			scaleFromCenter: {
				type: Boolean,
				default: true
			},
			enableNativeDrag: {
				default: true,
				type: Boolean
			},
			trTransform: {
				type: Object,
				default: () => ({})
			},
		    fatherScale: {
				type: Object,
				default: () => ({})
			},
		    selfScale: {
				type: Number,
				default: 1,
			},
			blockWidth: {
				type: Number,
				default: 0,
			},
			blockHeight: {
				type: Number,
				default: 0,
			},
		},
		data(){
			return {

			}
		},
		computed: {
			showData(){
				return (itemA) => {
					let name = this.dataName?itemA.name + ' : ':'';
          if(itemA.value!=0&&!itemA.value){
            return name
          }else{
            if(itemA.type == 'int' || itemA.type == 'float' || itemA.type == 'double'){
            	return name + itemA.value + ' ' + (itemA.unit ? itemA.unit : '')
            }else if(itemA.type == 'bool'){
            	return name + itemA.selectOptions[Number(itemA.value)] + ' ' + (itemA.unit ? itemA.unit : '')
            }else if(itemA.type == 'enum'){
            	return name + itemA.selectOptions.filter(i => i.id == Number(itemA.value))[0].name
            }else if(itemA.type == 'text' || itemA.type == 'date'){
            	return name + itemA.value + ' ' + (itemA.unit ? itemA.unit : '')
            }
          }
				}
			},
			computedStyles() {
				const {
					element,
					controls
				} = styler({
					x: this.x,
					y: this.y,
					scaleX: this.scaleX,
					scaleY: this.scaleY,
					width: this.width,
					height: this.height,
					angle: this.angle,
					disableScale: this.disableScale
				});
//				console.log(element)
				return {
					payload: {},
					element: {
						...element,
						width: element.width ? `${element.width}px` : null,
						height: element.height ? `${element.height}px` : null,
					},
					controls: {
						...controls,
						width: `${controls.width}px`,
						height: `${controls.height}px`
					}
				}
			},
			computedStylesBlock() {
				const {
					element,
					controls
				} = styler({
					x: this.x,
					y: this.y,
					scaleX: this.scaleX,
					scaleY: this.scaleY,
					width: this.width,
					height: this.height,
					angle: this.angle,
					disableScale: this.disableScale
				});
				/*找到中心点*/
				let arr = element.transform.split(',');
				let x = Number(this.computedStyles.element.transform.split(',')[4]);
				let width = parseInt(this.computedStyles.element.width);
				let ThisActiveX = x + (width / 2);
				arr[4] = ThisActiveX;
				element.transform = arr.toString();

				return {
					payload: {},
					element: {
						...element,
						width: null,
						height: null,
					},
				}
			},
			UpdataScale() {
				return{
					width: `${this.blockWidth/this.selfScale/this.fatherScale.scaleX}px !important`,
					height: `${this.blockHeight/this.selfScale/this.fatherScale.scaleY}px !important`,
					top: `-${this.blockHeight/this.selfScale/this.fatherScale.scaleY}px`
				}
			},
			NearEndClassFun() {
				if(this.item.rotateDeg == 30) {
					return 'NearEnd30'
				} else if(this.item.rotateDeg == 90) {
					return 'NearEnd90'
				} else {
					return 'FarEnd30'
				}
			},
			FarEndClassFun() {
				if(this.item.rotateDeg == 30) {
					return 'FarEnd30'
				} else if(this.item.rotateDeg == 90) {
					return 'FarEnd90'
				} else {
					return 'NearEnd30'
				}
			},
		},
		methods: {

			/*核心代码 ↓↓↓*/
			handleScale(scaleType, event) {

//				event.stopPropagation();
//				event.preventDefault();

				const drag = scale(scaleType, {
					startX: event.pageX,
					startY: event.pageY,
					x: this.x,
					y: this.y,
					scaleX: this.scaleX,
					scaleY: this.scaleY,
					width: this.width,
					height: this.height,
					angle: this.angle,
					scaleLimit: this.scaleLimit,
					scaleFromCenter: this.scaleFromCenter && event.altKey,
					enableScaleFromCenter: this.scaleFromCenter,
					aspectRatio: this.aspectRatio && event.shiftKey,
					enableAspectRatio: this.aspectRatio
				}, (payload) => {
					var stopX = (this.x - this.width * this.scaleX) + this.width,
						stopY = (this.y - this.height * this.scaleY) + this.height;
					payload.stopX = stopX;
					payload.stopY = stopY;
					payload.widthHandle = Math.round(this.width * payload.scaleX);
					payload.heightHandle = Math.round(this.height * payload.scaleY);
					payload.Change = 'handleScale';
					this.$emit("update", payload)
				});

				this.onDrag(drag);
			},
			handleTranslation(event) {
//				event.stopPropagation();
				const drag = translate({
					x: this.x,
					y: this.y,
					startX: event.pageX,
					startY: event.pageY
				}, (payload) => {
					var stopX = (this.x - this.width * this.scaleX) + this.width,
						stopY = (this.y - this.height * this.scaleY) + this.height;
					payload.stopX = stopX;
					payload.stopY = stopY;
					payload.Change = 'handleTranslation';
					this.$emit("update", payload)
				});

				this.onDrag(drag);
			},

			handleRotation(event) {
//				event.stopPropagation();

				const drag = rotate({
					startX: event.pageX,
					startY: event.pageY,
					x: this.x,
					y: this.y,
					scaleX: this.scaleX,
					scaleY: this.scaleY,
					width: this.width,
					height: this.height,
					angle: this.angle,
				}, (payload) => {
					payload.Change = 'handleRotation';
					this.$emit("update", payload)
				});

				this.onDrag(drag)
			},

			onDrag(drag) {
				var self = this;
				const up = () => {
					document.removeEventListener('mousemove', drag);
					document.removeEventListener('mouseup', up);
					var stopX = (this.x - this.width * this.scaleX) + this.width,
						stopY = (this.y - this.height * this.scaleY) + this.height;
					let payload = {
						stopX: stopX,
						stopY: stopY,
						centerPointX: this.x,
						centerPointY: this.y,
						Change: sessionStorage.getItem('currentPropsChange')
					}
					this.$emit("drag-end", payload);
				};

				document.addEventListener('mousemove', drag);
				document.addEventListener('mouseup', up);
			},
			mousedown(event) {
				if(this.enableNativeDrag) {
					var oEvent = event;
					oEvent.preventDefault && oEvent.preventDefault();
				}
				if(!this.spaceMark) {
					this.$emit("mousedown", event);
					if(this.selectOn === 'mousedown' || this.selected === true) {
						this.$emit('onSelect')
						this.handleTranslation(event)
					}
				}
				return false;
			},
			click(event) {
				this.$emit('click', event)
				if(this.selectOn === 'click') {
					this.$emit('onSelect')
				}
			},

			dblClick(event) {
				this.$emit('dblclick', event)
				if(this.selectOn === 'dblclick') {
					this.$emit('onSelect')
				}
			}

		},
	}
</script>
<style scoped>
	/*深色*/
	.fileDiv .DarkMould .topBox{
		background: rgb(9 28 49 / .4);
	    border: 1px solid rgba(24,147,252,1);
	    border-radius: 2px;
	}
	.fileDiv .DarkMould .topBox .Block-title{
		background: rgba(70,158,255,1);
	}

	.topBox{
		position: absolute;
	    background: rgba(44,63,83,.255);
	    border: 1px solid rgba(24,148,252,1);
	    border-radius: 2px;
	    bottom: 0;
	}
	.Block-box{
	    float: left;
	    width: max-content;
	    color: #fff;
	    line-height: 32px;
	    font-size: 20px;
	    text-indent: 20px;
	    margin-top: 5px;
	    margin-bottom: 5px;
	    min-width: calc(100% - 15px);
	    text-align: left;
	    padding-right: 15px;
	}

	/*滚动条样式：谷歌浏览器下*/

	.Block-body::-webkit-scrollbar {
		width: 8px;
		height: 8px;
		background-color: #f5f7fa;
	}
	/*滚动条的轨道*/

	.Block-body::-webkit-scrollbar-track {
		/*box-shadow: inset 0 0 5px rgba(0,0,0,.3);*/
		background-color: #FAFAFA;
	}
	/*滚动条的滑块按钮*/

	.Block-body::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background-color: #C2C2C2;
		/*box-shadow: inset 0 0 5px #000;*/
	}
	/*滚动条的上下两端的按钮*/

	.Block-body::-webkit-scrollbar-button {
		height: 0px;
		background-color: #B0AEDA;
	}
	.Block-body{
		    float: left;
	    overflow-y: auto;
	    overflow-x: hidden;
	    /* width: max-content; */
	    /* height: calc(100% - 38px); */
	    margin-bottom: 10px;
	    position: relative;
	    /* left: 0; */
	    /* right: 0; */
	    margin: auto;
	    /* top: 43px;*/
	}
	.Block-title{
		font-size: 24px;
	    color: #fff;
	    line-height: 43px;
	    text-indent: 18px;
	    margin-top: 5px;
	    margin-left: 3px;
	    margin-right: 3px;
	    background: rgba(70,158,255,1);
	    white-space: nowrap;
	    position: relative;
	    left: 0;
	    right: 0;
	    margin: auto;
	    text-align: left;
        padding-right: 15px;
	}
	.Block_circ{
		position: absolute;
	    bottom: -6px;
	    left: -2px;
	    right: 0;
	    margin: auto;
	    background-color: #4DADFF;
	    width: 6px;
	    height: 6px;
	    border-radius: 50%;
	}
	.Block_line{
		position: absolute;
	    bottom: -38px;
	    left: 0;
	    right: 0;
	    margin: auto;
	    height: 39px;
	    width: 2px;
	    background-color: #4DADFF;
	}
	.abBox{
		position: absolute;
	    margin: auto;
	    width: max-content;
	}
	.AltBlock{
        border-radius: 2px;
	    width: 195px;
	    height: auto;
	    z-index: 999999;
	    left: -97.5px;
	    top: -20px;
	}
	.zjt {
		z-index: 45;
	}

	.NearEnd30 {
		position: absolute;
		/*left: -20px;*/
		/*transform: rotate(-30deg);*/
		top: -10px;
	}

	.FarEnd30 {
		position: absolute;
		/*right: -25px;*/
		/*transform: rotate(-30deg);*/
		top: -8px;
	}

	.NearEnd90 {
		position: absolute;
		left: -9px;
		/*transform: rotate(-30deg);*/
		/*top: -10px;*/
	}

	.FarEnd90 {
		position: absolute;
		right: -11px;
		/*transform: rotate(-30deg);*/
		/*top: -8px;*/
	}

	.clearfix:after {
		content: "";
		display: block;
		clear: both;
	}

	* {
		-webkit-touch-callout: none;
		/*系统默认菜单被禁用*/
		-webkit-user-select: none;
		/*webkit浏览器*/
		-khtml-user-select: none;
		/*早期浏览器*/
		-moz-user-select: none;
		/*火狐*/
		-ms-user-select: none;
		/*IE10*/
		user-select: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/MapEditor/Preview/FreeTransform.vue